import React, { useEffect, useState } from "react"
import Pagination from "src/components/tailwind-components/Pagination"
import { useGetCompanies } from "../hooks/useGetCompanies"
import { CompanyTable } from "./CompanyTable"

export const CompanyList: React.FC<{}> = () => {
  const PER_PAGE = 100

  const [page, setPage] = useState(1)
  const [searchTerm, setSearchTerm] = useState("") // 検索ワード(SWRに渡す用)
  const [searchTermInputValue, setSearchTermInputValue] = useState("") // 検索ワード(入力フォーム用)

  // APIフックからデータを取得
  const { companies, pagination, isLoading, error } = useGetCompanies({
    page: page,
    per: PER_PAGE,
    search: searchTerm,
  })

  // 検索時にページをリセット
  useEffect(() => {
    setPage(1)
  }, [searchTerm])

  // Enterキーハンドラー
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && !e.nativeEvent.isComposing) {
      // Enterキーが押されたら、SWRに渡す検索ワードを更新
      setSearchTerm(searchTermInputValue)
    }
  }

  return (
    <div className="overflow-hidden rounded-lg bg-white">
      <div className="mb-6 px-4">
        <div className="relative max-w-md">
          <input
            type="text"
            placeholder="事業者名で検索..."
            value={searchTermInputValue}
            onChange={(e) => setSearchTermInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
            className="w-full rounded-lg border border-gray-300 px-4 py-2 pr-10 text-[1.6rem] min-h-[48px]"
          />
        </div>
      </div>
      <CompanyTable companies={companies} isLoading={isLoading} isError={error !== undefined} />
      {pagination && (
        <div className="pb-8 pt-4">
          <Pagination pagination={pagination} onPageChange={setPage} />
        </div>
      )}
    </div>
  )
}
